/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    string, bool, array, shape,
} from 'prop-types';

import { Star, StarHalf } from '@material-ui/icons';
import { useSelector } from 'react-redux';
import ResponsiveImage from '../../../GraphqlCommonComponents/ResponsiveImage/ResponsiveImage';
import { getFeatureFlag } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import useIsDisplayChannel from '../../../../../helpers/hooks/useIsDisplayChannel';

const useStyles = makeStyles((theme) => ({
    passportEligibleImage: {
        width: '24%',
        [theme.breakpoints.down('md')]: {
            width: '45%',
            marginBottom: '10px',
        },
        [theme.breakpoints.down(600)]: {
            display: 'block',
            width: '38%',
            margin: '0 auto 5px',
        },
    },
    plaEnabledProductTitle: {
        display: 'block',
        [theme.breakpoints.down(600)]: {
            display: 'flex',
            alignItems: 'center',
            padding: '0 10px',
            marginBottom: '5px',
            columnGap: '6px',
        },
    },
    reviewCountContainer: {
        display: 'flex',
    },
    reviewCount: {
        fontSize: '10px',
    },
    ratingStars: {
        display: 'flex',
        '& svg': {
            width: '12px',
            height: '12px',
        },
    },
    plaProdName: {
        margin: '2px 10px 0px 11px',
        fontSize: '20px',
        fontWeight: '600',
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
        color: theme.palette.black || '#000',
    },
    shopperApproveContainer: {
        '& img': {
            width: '80px',
        },
    },

    simpleProductTitle: {
        display: 'flex',
        flexDirection: 'column',
    },
    plaEnabledPassportImage: {
        width: '170px',
        [theme.breakpoints.down('md')]: {
            width: '45%',
        },
        [theme.breakpoints.down(600)]: {
            width: '100px',
            display: 'block',
        },
    },
    productName: {
        width: '100%',
        marginTop: 0,
        fontSize: '24px',
        [theme.breakpoints.down('md')]: {
            marginBottom: '10px',
        },
        [theme.breakpoints.down(767)]: {
            display: 'none',
        },
    },
    foodProductName: {
        [theme.breakpoints.down(767)]: {
            display: 'block',
        },
    },
    passportProductName: {
        margin: 0,
        [theme.breakpoints.down(600)]: {
            display: 'none',
        },
    },
    sellerName: {
        color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        margin: '0px 11px',
        '& span': {
            fontWeight: 'bold',
        },
    },
}));

const PLAMobileProductTitle = ({
    isPlaEnabled,
    presentationFamily,
    isPassportBannerEnabled,
    productName,
    selectedSku,
    productBrandId,
    showShopName,
}) => {
    const classes = useStyles();
    const sellerNameEnabled = useSelector(getFeatureFlag('is-seller-name-shown'));
    const sellerName = showShopName ? selectedSku?.marketplaceShopDetails?.shopName || '' : '';
    const isDisplayChannel = useIsDisplayChannel() && presentationFamily === 'flower';

    const renderPassportImage = () => {
        if (presentationFamily === 'flower' && isPassportBannerEnabled) {
            return (
                <ResponsiveImage
                    className={isPlaEnabled || isDisplayChannel ? classes.plaEnabledPassportImage : classes.passportEligibleImage}
                    path="https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt8d4549d3cac15860/61e09d4f2e109d6c649d4aa4/PP_EligibleIcon.svg"
                    alt="Passport Eligible"
                />
            );
        }
        return null;
    };

    return (
        <>
            <div className={classes.plaProdName}>{productName}</div>
            <div className={isPlaEnabled || isDisplayChannel ? classes.plaEnabledProductTitle : classes.simpleProductTitle} aria-hidden="true">
                {(isPlaEnabled || isDisplayChannel) && renderPassportImage()}
                <div className={classes.reviewCountContainer}>
                    <div className={classes.ratingStars}>
                        <Star />
                        <Star />
                        <Star />
                        <Star />
                        <StarHalf />
                    </div>
                </div>
                <div className={classes.reviewCount}>254,268 reviews</div>
                <div className={classes.shopperApproveContainer}>
                    <img src="https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/bltab0819c5ba8dff60/5e28ea9fe2b3975498eaf8d3/salogo.png" className={classes.shopperApproveIcon} alt="Shopper Approved Logo" />
                </div>
            </div>
            {sellerNameEnabled && sellerName && (productBrandId === '1026' || productBrandId === '1027') && <p className={classes.sellerName}>Created & Shipped By: <span>{sellerName}</span></p>}
        </>
    );
};

PLAMobileProductTitle.propTypes = {
    isPassportBannerEnabled: bool.isRequired,
    isPlaEnabled: bool.isRequired,
    presentationFamily: string.isRequired,
    productName: array.isRequired,
    productBrandId: string,
    selectedSku: shape({
        marketplaceShopDetails: shape({
            shopName: string,
        }),
    }),
    showShopName: bool,
};
PLAMobileProductTitle.defaultProps = {
    selectedSku: {},
    productBrandId: '',
    showShopName: false,
};
export default PLAMobileProductTitle;
